import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "border rounded-md" }
const _hoisted_2 = { class: "relative slide" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "carousel-indicators absolute bottom-0 flex h-24 w-full justify-center items-center" }, null, -1)
const _hoisted_4 = { class: "flex justify-center" }
const _hoisted_5 = { class: "carousel-inner relative overflow-hidden w-full border rounded-md" }
const _hoisted_6 = ["id"]
const _hoisted_7 = ["src"]

import { ref, onMounted } from 'vue';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'Carousel',
  props: {
    photoUrl: Array as () => string[]
  },
  setup(__props) {

const props = __props;

  

  
  const active = ref(0);
  
  onMounted(() => {
    let i = 0;
    setInterval(() => {
      if (i > props.photoUrl.length - 1) {
        i = 0;
      }
      active.value = i;
      i++;
    }, 2000);
  });
  
return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.photoUrl, (img, i) => {
            return (_openBlock(), _createElementBlock("div", {
              id: `slide-${i}`,
              key: i,
              class: _normalizeClass([{ 'active': active.value === i, 'left-full': active.value !== i }, "carousel-item inset-0 relative w-full transform transition-all duration-1000 ease-in-out"])
            }, [
              _createElementVNode("img", {
                class: "block w-full",
                src: img,
                alt: "Slide"
              }, null, 8, _hoisted_7)
            ], 10, _hoisted_6))
          }), 128))
        ])
      ])
    ])
  ]))
}
}

})